<template>
  <div id="fitnessAnalysis">
    <div class="heard">
      <div>体测项目：{{ info.projectName }}</div>
      <div class="heard-box">
        <div class="user-info-box-item">
          <div class="heard-box-img">
            <van-image width="100%" height="100%" :src="faceData" rel="external nofollow" />
          </div>
          <div>
            <div class="heard-box-info">{{ info.studentName }}</div>
            <div>{{ info.snCode }}</div>
          </div>
        </div>
        <div class="user-info-box-item">
          <div class="user-info-box-item-right user-info-box-item-border">
            <div><span>{{ bestScore }}</span>{{ projectUnit }}</div>
            <div>最佳成绩</div>
          </div>
          <div class="user-info-box-item-right">
            <div><span>{{ sort }}</span>名</div>
            <div>校园排名</div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-eachart" ref="comprehensive"></div>
    </div>
    <div class="card">
      <div class="card-eachart" ref="single"></div>
    </div>
    <div class="card">
      <div class="card-title">测试记录</div>
      <div class="card-table">
        <div class="card-td">
          <div class="card-td-item">序号</div>
          <div class="card-td-time">测试时间</div>
          <div class="card-td-item">测试成绩</div>
        </div>
        <div class="card-td" v-for="(item, index) in testScoreList" :key="index">
          <div class="card-td-item">{{ index + 1 }}</div>
          <div class="card-td-time">{{ item.testTime }}</div>
          <div class="card-td-item">{{ item.score }}{{ item.projectUnit }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  queryTestRecord,
  querySingleAnalysis
} from '@/api/fitnessReport'
import * as echarts from 'echarts'
export default {
  name: 'fitnessAnalysis',
  data () {
    return {
      bestScore: '',
      sort: '',
      projectUnit: '',
      info: {},
      testScoreList: [],
      loading: false,
      faceData: ''
    }
  },
  created () {
    this.info = this.$route.query
    this.userInfo = JSON.parse(this.$route.query.data)
    console.log(this.userInfo)
    if (this.userInfo.faceData && this.userInfo.faceData.indexOf('data:image/jpeg;base64,') < 0) {
      this.faceData = 'data:image/jpeg;base64,' + this.userInfo.faceData
    } else {
      this.faceData = this.userInfo.faceData
    }
    this.queryTestRecord()
  },
  mounted () {
    this.querySingleAnalysis()
  },
  methods: {
    async querySingleAnalysis () {
      const legend1 = []
      const series1 = []
      let projectUnit1 = ''
      let xaxisData1 = []
      const legend2 = []
      const series2 = []
      let projectUnit2 = ''
      let xaxisData2 = []
      await querySingleAnalysis({
        snCode: this.info.snCode,
        projectCode: this.info.projectCode
      }).then((data) => {
        const body = data.body
        this.bestScore = body?.bestScore
        this.sort = body?.sort
        this.projectUnit = body.projectUnit
        console.log(body)
        projectUnit1 = body?.achievementAnalysisVo?.projectUnit
        xaxisData1 = body?.achievementAnalysisVo?.xaxisData
        const seriesMap1 = body?.singleAchievement?.series || []
        seriesMap1.map((item) => {
          item.type = 'line'
          item.stack = 'Total'
          item.label = {
            formatter: function (params) {
              return (params.value)
            }
          }
          legend1.push(item.name)
          series1.push(item)
        })
        projectUnit2 = body?.singleAchievement?.projectUnit
        xaxisData2 = body?.singleAchievement?.xaxisData
        const seriesMap2 = body?.singleAchievement?.series || []
        seriesMap2.map((item) => {
          item.type = 'line'
          item.stack = 'Total'
          item.label = {
            formatter: function (params) {
              return (params.value)
            }
          }
          legend2.push(item.name)
          series2.push(item)
        })
      })

      this.getComprehensive(projectUnit1, legend1, xaxisData1, series1)
      this.getSingle(projectUnit2, legend2, xaxisData2, series2)
    },
    async queryTestRecord () {
      this.loading = true
      await queryTestRecord({
        snCode: this.info.snCode,
        projectCode: this.info.projectCode
      }).then((data) => {
        this.loading = false
        console.log(data)
        const records = data.body?.records || []
        this.testScoreList = records
      }).catch(() => {
        this.loading = false
      })
    },
    getComprehensive (projectUnit, legend, xaxisData, series) {
      const dom = this.$refs.comprehensive
      if (dom) {
        const myChart = echarts.init(dom)
        const option = {
          title: {
            text: '学年综合成绩分析',
            subtext: '单位：' + projectUnit,
            textStyle: {
              fontSize: 16,
              fontWeight: 500
            }
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: legend,
            left: 'right',
            top: 0,
            orient: 'vertical'
          },
          grid: {
            top: '25%',
            left: '5',
            right: '5',
            bottom: '5',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: xaxisData
          },
          yAxis: {
            type: 'value'
          },
          series: series
        }
        if (option && typeof option === 'object') {
          myChart.setOption(option)
        }
        window.addEventListener('resize', myChart.resize)
      }
    },
    getSingle (projectUnit, legend, xaxisData, series) {
      const dom = this.$refs.single
      if (dom) {
        const myChart = echarts.init(dom)
        const option = {
          title: {
            text: '个人单项成绩趋势分析',
            subtext: '单位：' + projectUnit,
            textStyle: {
              fontSize: 16,
              fontWeight: 500
            }
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: legend,
            left: 'right',
            top: 0,
            orient: 'vertical'
          },
          grid: {
            top: '25%',
            left: '5',
            right: '5',
            bottom: '5',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: xaxisData
          },
          yAxis: {
            type: 'value'
          },
          series: series
        }
        if (option && typeof option === 'object') {
          myChart.setOption(option)
        }
        window.addEventListener('resize', myChart.resize)
      }
    }
    // handleTableChange(pagination) {
    //   console.log(pagination);
    //   this.pagination.current = pagination.current
    //   this.queryTestRecord()
    // }
  }
}
</script>

<style lang="less" scoped>
#fitnessAnalysis {
  .heard {
    margin: 10px;
    padding: 10px;
    border-radius: 10px;
    color: #fff;
    background: no-repeat 100% 100% url('../../../assets/background/fitnessAchievement.jpg');
    font-size: 12px;

    .heard-box {
      margin: 20px 0 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .user-info-box-item {
        display: flex;
        align-items: center;

        .user-info-box-item-right {
          padding: 0 10px;
          text-align: center;
        }

        .user-info-box-item-border {
          border-right: 1px solid #ffffff;
        }

        .heard-box-img {
          margin-right: 10px;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          overflow: hidden;
        }

        .heard-box-info {
          line-height: 20px
        }
      }

    }
  }

  .card {
    margin: 10px;
    padding: 10px;
    border-radius: 10px;
    background: #ffffff;

    .card-table {
      width: 100%;
      color: #8B8B8B;

      .card-td {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-flow: wrap;
        width: 100%;
        font-size: 12px;
        height: 40px;
        border-bottom: 1px solid #f5f5f5;
      }

      .card-td-time {
        text-align: center;
        width: 50%;
      }

      .card-td-item {
        text-align: center;
        width: 25%;
      }
    }

    .card-eachart {
      width: 100%;
      height: 300px;
    }

  }
}
</style>
